export const capitalizeFirstLetter = (str: string): string => {
    return str.charAt(0).toUpperCase() + str.slice(1)
}

export const pluralize = (str: string, num: number): string => {
    return str + (num === 1 ? '' : 's')
}

